import React from "react";
import Header from "../components/Header";
import VideoHero from "../components/VideoHero";
import FeaturedProjects from "../components/FeaturedProjects";
import Services from "../components/Services";
import Stats from "../components/Stats";
import Gallery from "../components/Gallery";
import ClientsMarquee from "../components/ClientsMarquee";
import ContactCTA from "../components/ContactCTA";
import { LatestImpactStory } from "../components/LatestImpactStory";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="relative">
      <Header />
      <main>
        <VideoHero />
        <FeaturedProjects />
        <Services />
        <Stats />
        <LatestImpactStory />
        <Gallery />
        <ClientsMarquee />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
